import { Modal, ModalProps, ButtonLink } from "@skailer-com/uikit";
import { EmployeeViewContent } from "@/pages/employees/widgets/EmployeeViewContent.tsx";
import analyticsService, {
  analyticEvents,
  analyticProperties,
} from "@/services/analytics-service.ts";
import { ApiEmployee } from "@/types/employees/employee.types.ts";
import { useTranslation } from "react-i18next";
import { useEffectOnce } from "react-use";

export interface EmployeeViewModalProps extends ModalProps {
  employee?: ApiEmployee;
  employeeId?: number;
}

export function EmployeeViewModal({ employee, employeeId, ...props }: EmployeeViewModalProps) {
  const { t } = useTranslation();

  useEffectOnce(() => {
    analyticsService.trackEvent(analyticEvents.employees.viewedEmployee, {
      [analyticProperties.id]: employeeId ?? employee?.id,
      [analyticProperties.source]: "Modal",
    });
  });

  return (
    <Modal
      {...props}
      title={t("core:profile")}
      withCloser
      closeByEscEnabled
      size="md"
      variant={"side"}
      layout={"stretch"}
      closeByOutsidePress
      actions={
        <ButtonLink
          className="w-full mt-4"
          size="lg"
          href={`/employees/${employeeId ?? employee?.id}`}
          blank={true}
        >
          {t("core:view_profile")}
        </ButtonLink>
      }
    >
      <EmployeeViewContent employee={employee} employeeId={employeeId} />
    </Modal>
  );
}
